<template>
    <el-dialog title="新增艺人" :visible="dialogVisible" class="form-dialog" :append-to-body="true"
        @update:visible="updateDialogVisible" @open="dialogOpenCallback" @closed="dialogClosedCallback" center
        width="500px">
        <el-form ref="saveForm" label-position="left" :model="formData" :rules="rules" label-width="140px">
            <el-form-item label="艺人名称" prop="name">
                <el-input v-model="formData.name" :maxlength="250" autocomplete="off" placeholder="请输入"
                    @blur="formData.name && formData.name.trim() === '' && (formData.name = '')"></el-input>
            </el-form-item>
            <el-form-item label="性别/类型" prop="gender">
                <el-select v-model="formData.gender" :filterable="true" placeholder="请选择">
                    <el-option v-for="item in genderOptions" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="updateDialogVisible(false)">取消</el-button>
                <el-button type="primary" :loading="saveLoading" @click="save">保存</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
export default {
    props: {
        // 窗口显示状态
        dialogVisible: {
            type: Boolean,
            default: false
        },
        // 艺人名称
        artistName: {
            type: String,
            default: ''
        }
    },
    data() {
        this.formDataDef = {
            // 艺人名称 | 必填、长度250
            name: '',
            // 性别 | 必填 | 0--未知、1--男、2--女、3--组合、4--乐队、5--其他
            gender: null
        };

        return {
            formData: { ...this.formDataDef },
            rules: {
                name: { required: true, message: '请输入艺人名称', trigger: 'change' },
                gender: { required: true, message: '请选择性别/类型', trigger: 'change' }
            },
            saveLoading: false
        };
    },
    computed: {
        genderOptions() {
            return [
                { label: '未知', value: 0 },
                { label: '男', value: 1 },
                { label: '女', value: 2 },
                { label: '组合', value: 3 },
                { label: '乐队', value: 4 },
                { label: '其他', value: 5 }
            ];
        }
    },
    methods: {
        // 窗口显示隐藏设置
        updateDialogVisible(flag) {
            this.$emit('update:dialogVisible', flag);
        },
        // 窗口打开回调 处理数据初始化
        dialogOpenCallback() {
            this.formData.name = this.artistName.substring(0, 250);

            if (this.$refs['saveForm']) {
                this.$refs['saveForm'].clearValidate();
            }
        },
        // 窗口关闭回调 重置组件状态为初始值
        dialogClosedCallback() {
            this.formData = { ...this.formDataDef };
        },
        // 新增艺人
        save() {
            this.$refs['saveForm'].validate(valid => {
                if (!valid) {
                    return;
                }

                this.saveLoading = true;

                this.$request({
                    url: '/artist/add/add_artist.json',
                    data: this.formData,
                    method: 'post',
                    formData: false
                })
                    .then(res => {
                        if (!res.data.state) {
                            this.$message({ message: res.data.msg, type: 'error' });
                            throw new Error(res.data.msg);
                        }

                        this.$message({ message: '新增艺人成功', type: 'success' });
                        this.updateDialogVisible(false);

                        this.$emit('add-success', {
                            artistId: res.data.result.id,
                            artistName: res.data.result.name
                        });
                    })
                    .finally(() => {
                        this.saveLoading = false;
                    });
            });
        }
    }
};
</script>
